import type { CSSProperties, ReactNode } from 'react';

/** 卡片排列方向 */
export type CutdownCardLayout = 'horizontal' | 'vertical';

/** 时间单位键 */
export type CutdownCardTimeUnit = 'days' | 'hours' | 'minutes' | 'seconds';

export const CUTDOWN_CARD_UNIT_LABELS: Record<CutdownCardTimeUnit, string> = {
  days: '天',
  hours: '时',
  minutes: '分',
  seconds: '秒',
};

export const DEFAULT_CUTDOWN_CARD_UNITS: CutdownCardTimeUnit[] = [
  'days',
  'hours',
  'minutes',
  'seconds',
];

export type CutdownCardStyleProps = {
  /** 卡片圆角，默认 0 */
  borderRadius?: number | string;
  /** 卡片背景色，默认 #ebebeb */
  backgroundColor?: string;
  /** 卡片边框，默认 1px solid #404040 */
  border?: string;
  /** 数字颜色，默认 #000 */
  numberColor?: string;
  /** 单位标签颜色，默认 #000 */
  labelColor?: string;
  /** 单张卡片边长（px），默认 72 */
  cardSize?: number;
  /** 卡片间距（px），默认 8 */
  gap?: number;
  /** 整体缩放，默认 1；文字与卡片同比例缩放 */
  scale?: number;
};

export type CutdownCardProps = CutdownCardStyleProps & {
  /** 倒计时目标时间；未设置或已到期时展示 0 天 0 时 0 分 0 秒 */
  date?: Date | string | number | null;
  layout?: CutdownCardLayout;
  /** 显示的时间单位，默认天/时/分/秒 */
  units?: CutdownCardTimeUnit[];
  /** 数字切换动画（自上向下滑入/滑出） */
  animate?: boolean;
  /** 数字是否补零，默认 false；传数字表示补零位数（如 2 → 05） */
  zeroPad?: boolean | number;
  className?: string;
  style?: CSSProperties;
  /** 倒计时结束时的展示内容 */
  completedContent?: ReactNode;
  /** 倒计时归零时回调（仅触发一次） */
  onComplete?: () => void;
};

export type CutdownCardUnitProps = {
  display: string;
  label: string;
  animate: boolean;
  cardSize: number;
  borderRadius: number | string;
  backgroundColor: string;
  border: string;
  numberColor: string;
  labelColor: string;
};
